import { render, staticRenderFns } from "./BillingAddressFormTab.vue?vue&type=template&id=115ce1d0"
import script from "./BillingAddressFormTab.vue?vue&type=script&lang=js"
export * from "./BillingAddressFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports